const API_BASE_PATH = '/uploads'

const UPLOADS = {
  MINIO_URL: `${API_BASE_PATH}/minio_url`
}

export default UPLOADS
